module.exports = __webpack_public_path__ + "static/media/person-icon-light.7d927e67.svg";